import { Account } from 'types/Account'
import { ProductsSettings } from 'types/ProductSettings'
import { LicensesDetails } from './fetchLicensesDetails'
import fetchProductSettings from './fetchProductSettings'

const fetchAccountSettings = async (licensesDetails: LicensesDetails, currentAccount: Account) => {
  const productsList = ['G2M', 'G2ARS', 'GOTORESOLVE', 'jive'] // Add or remove products as needed
  const productsToFetch = productsList.filter((product) => licensesDetails.products.includes(product.toUpperCase()))

  const fetchProductSettingsForAccount = async (accountKey: string, product: string) => {
    const productSettings = await fetchProductSettings(accountKey, product)
    return { [product]: productSettings }
  }

  const fetchAllProductSettings = async (accountKey: string, products: string[]) => {
    const productSettingsPromises = products.map((product) => fetchProductSettingsForAccount(accountKey, product))
    const productSettings = await Promise.all(productSettingsPromises)
    return Object.assign({}, ...productSettings)
  }

  const settings: ProductsSettings = await fetchAllProductSettings(currentAccount.key, productsToFetch)
  return settings
}
export default fetchAccountSettings
